import React, { Component } from 'react';
import { startSnowFunction } from './startSnow';

export class GoSnow extends Component {

    componentDidMount () {
        startSnowFunction( this.props.width, this.props.height );
    }

    render() {

        const {
            width,
            height,
            zIndex
        } = this.props;

        return <canvas
            style={
                {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width,
                    height,
                    zIndex
                }
            }
            className='webgl'>

        </canvas>
    }
}